import { useMemo } from 'react';
import { useChainMenuSettingsApiQuery } from './useChainMenuSettingsApiQuery';

export const useIsUsingBuyingBudget = () => {
    const { data } = useChainMenuSettingsApiQuery();

    return useMemo(() => {
        return !!data?.find((item) => item.menu.toString() === 'BuyingBudget')?.visible;
    }, [data]);
};
